module.exports = __webpack_public_path__ + "img/data-logo.f5f7ac53.png";